module.exports = __webpack_public_path__ + "img/FR14218.fb97b2d0.png";